module.exports = __webpack_public_path__ + "static/media/DanceMode.f8f97863.gif";